/**
 * @deprecated Import from `util/mixedInnerTooltip` instead.
 * Kept for backward compatibility with intent-specific call sites.
 */
import {
  computeMixedInnerTooltipBreakdown as computeGenericBreakdown,
  resolveMixedInnerTooltipSource as resolveGenericSource,
} from "./mixedInnerTooltip";

export function computeMixedInnerTooltipBreakdown(mixedReviewCount, intentEntries) {
  return computeGenericBreakdown(mixedReviewCount, intentEntries, {
    labelKey: "intent",
    excludeLabels: ["mixed"],
  }).map((row) => ({
    intent: row.label,
    count: row.count,
    percentage: row.percentage,
  }));
}

export function resolveMixedInnerTooltipSource(rowPayload) {
  const source = resolveGenericSource(rowPayload, { entriesKey: "intents" });
  return {
    mixedReviewCount: source.mixedReviewCount,
    intents: source.entries,
  };
}
